export default __webpack_public_path__ + "static/century2-e14854535057d32e83b74fd78887cb3f.png";